import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { ArrowLeft } from "lucide-react";

const AIODSImageViewer = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'LL/Mura/Spot/Line/Band Issue Detection',
      description: 'Starts issue detection',
      path: '/productinfodetection',
    },
    {
      title: 'LL/Mura/Spot/Line/Band Issue Labeling',
      description: 'Labels mura, spot, line, band, and light leakage issues',
      path: '/mura-labeling',
    },
  ];
  const handleBack = () => {

    navigate('/dashboard');

  };

  const handleMenuClick = (item) => {
    navigate(item.path);
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <div className="sm:p-4 mt-4 border-b border-gray-800 ">
        <div className="flex items-center gap-2 sm:gap-3 sm:mb-3 mb-2 p-1">

          <ArrowLeft
            onClick={handleBack}
            className="w-5 h-5 sm:w-6 sm:h-6 font-bold cursor-pointer "
          />

          <h1 className="font-semibold text-base sm:text-2xl">
            AI Optical Detection System (AI-ODS)
          </h1>

        </div>
      </div>
      {/* Menu Items */}
      <div className="px-4 w-full flex-1 pb-20 sm:pl-11">
        {menuItems.map((item, index) => (
          <div key={index} className="w-full">
            <button
              onClick={() => handleMenuClick(item)}
              className="
                p-2 w-full flex items-center justify-between 
                py-4 border-b border-gray-800 
                group min-h-[72px] 
                hover:bg-gray-800/70 
                transition-colors cursor-pointer
              "
            >
              <div className="flex flex-col items-start max-w-full text-left">
                <span className="font-medium text-white text-base sm:text-xl whitespace-normal break-words">
                  {item.title}
                </span>
                <span className="text-xs md:text-sm text-gray-400 whitespace-normal break-words mt-1">
                  {item.description}
                </span>
              </div>

              <ChevronRight
                className="w-5 h-5 text-gray-300 group-hover:text-white ml-3 flex-shrink-0"
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIODSImageViewer;